module.exports = __webpack_public_path__ + "media/components/theme/fonts/CooperHewitt-Bold-a3a94bf1a465c8a1608b69ff9926fd7c.woff";